import React from 'react';
import { useState } from 'react';
import { Button, Typography, styled } from "@mui/material";
import { NavHashLink } from 'react-router-hash-link';
import { Grid } from "@mui/material";



const CustomTypography = styled(Typography) ({
    fontSize: '1rem',
    textAlign: 'start',
    lineHeight: '1.5',
    color: '#ffffff',
    marginTop: '1.5rem',
    
    
})


const Content = () => {
  
  return (    
    
    
      
   
         
        <Grid container spacing={0}   
        sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            minHeight: 300,
            height:'fit-content',
            justifyContent: 'center',
            alignItems: 'center',
            verticalAlign: 'middle',
            py: 2,
            px: 2,
            backgroundImage: "url('https://res.cloudinary.com/dpy1up1n6/image/upload/v1688923678/egress-windows/rs_w_1023_m_uzrjok.jpg')",
            backgroundColor: 'rgba(0,0,0,0.7)',
            backgroundBlendMode: 'overlay',
            objectFit: 'cover',
            marginBottom: '0px auto',
            marginTop: '0px auto',
            borderTop: 10,
            borderBottom: 10,
            borderColor: '#121212',
            padding: '20px',
            paddingTop:'40px',
            paddingBottom: '40px',
            zIndex: 0,
           
            
        }}
        >
<CustomTypography>
<Typography
                variant='h4'
                component= 'h4'
                width='90vw'
                maxWidth='900px'
                sx={{
                    fontWeight: 600,
                    color: '#fff',
                    maxWidth:'85vw',
                }}
                textAlign={'center'}
                >
                    Contact us for a free quote.
                </Typography>
                    
</CustomTypography>

<Button
  component={NavHashLink}
  to={'/contact#quote-form'}
  variant="contained"
  type="submit"
  size="medium"
  padding='20px'
  sx={{
    fontSize: '2rem',
    fontFamily: 'Roboto',
    textTransform: 'capitalize',
    padding: '20px',
    py: 2,
    px: 4,
    mt: 3,
    mb: 2,
    width: '250px',
    borderRadius: 1.5,
    backgroundColor: '#4dc548',
    zIndex: 4,
    "&:hover": {
      backgroundColor: '#0deb2a',
    }
  }}
>
  Get Quote
</Button>

                
            
            
            

            

            

            

            

            
        </Grid>
    );
    
}

export default Content